/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { Dispatch, SetStateAction } from 'react';
import { Button, Field, Typography } from '@lamimed/pantheon';

import { useFormSubmit } from '../hooks/useFormSubmit';
import { usePrescriptionUpload } from '../hooks/usePrescriptionUpload';
import * as S from '../styles';

interface PersonalInfoProps {
  currentStep: number;
  setCurrentStep: Dispatch<SetStateAction<number>>;
  onDone: () => void;
}

export const PersonalInfo: React.FC<PersonalInfoProps> = ({
  currentStep,
  setCurrentStep,
  onDone,
}) => {
  const { Controller, handleSubmit, onSubmit, control, errors, loading } =
    useFormSubmit();
  const { urls } = usePrescriptionUpload();

  const isButtonDisabled = !errors || loading;

  return (
    <S.FormWrapper
      onSubmit={handleSubmit(async (data) => {
        const payload = {
          ...data,
          photos: urls,
        };

        onSubmit(payload, onDone);
      })}
    >
      <S.TextContainer margin="medium">
        <Typography
          variant="heading_2"
          color="text__highlight"
          textAlign="center"
        >
          Inserisci i tuoi dati
        </Typography>
      </S.TextContainer>

      <S.TextContainer margin="medium">
        <Typography variant="body_text_2" textAlign="center">
          Riceverai il preventivo via Email entro 1 ora (lun-ven)
        </Typography>
      </S.TextContainer>

      <S.FormContainer>
        <S.FieldContainer error={!!errors.name}>
          <Controller
            control={control}
            name="name"
            render={({ field: { ref, ...fieldProps } }) => (
              <Field
                id="name"
                label="Nome Cognome*"
                variant={errors.name ? 'error' : 'primary'}
                error={errors.name?.message}
                {...fieldProps}
              />
            )}
          />
        </S.FieldContainer>

        <S.FieldContainer error={!!errors.phone}>
          <Controller
            control={control}
            name="phone"
            render={({ field: { ref, ...fieldProps } }) => (
              <Field
                id="phone"
                label="Telefono*"
                type="tel"
                variant={errors.phone ? 'error' : 'primary'}
                error={errors.phone?.message}
                {...fieldProps}
              />
            )}
          />
        </S.FieldContainer>

        <S.FieldContainer error={!!errors.email}>
          <Controller
            control={control}
            name="email"
            render={({ field: { ref, ...fieldProps } }) => (
              <Field
                id="email"
                label="E-mail*"
                type="email"
                variant={errors.email ? 'error' : 'primary'}
                error={errors.email?.message}
                {...fieldProps}
              />
            )}
          />
        </S.FieldContainer>
      </S.FormContainer>

      <S.ButtonsContainer>
        <Button
          variant="clear"
          shrinked
          extended
          onClick={() => setCurrentStep(currentStep - 1)}
        >
          Indietro
        </Button>

        <Button
          shrinked
          extended
          type="submit"
          disabled={isButtonDisabled}
          data-tracking-id="invia"
        >
          Conferma
        </Button>
      </S.ButtonsContainer>
    </S.FormWrapper>
  );
};
